export default "__VITE_ASSET__Ch7MD7hd__"